import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { search_icon, view_icon } from "../../assets/imgs";
import { Table } from "../../components/Table/Table";
import {
  allocatedAlerts,
  companyDetails,
  siteDetails,
  recentAlerts,
} from "../redux/api/dummyJson";
import CommonDatePicker from "../../components/CommonDatePicker";
import SelectBox from "../../components/SelectBox";
import moment from "moment/moment";

const Allocated = ({
  site,
  sites,
  setSites,
  siteList,
  setSiteList,
  companies,
  setCompanies,
  comapanyList,
  page,
  setPage,
  pagination,
  setPagination,
  list,
  setList,
  typeDrop,
  setTypeDrop,
  cam,
  setCam,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  searchText,
  setSearchText,
  getNotification,
}) => {
  const [companyData, setCompanyData] = useState([]);

  //   const [company, setCompany] = useState([]);
  const [data, setData] = useState([]);

  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Date and Time",
        accessor: "captured_at",
        Cell: ({ value, row }) => {
          return (
            <p> {value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"}</p>
          );
        },
      },
      {
        Header: "Camera Number",
        accessor: "camera_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Camera Name",
        accessor: "camera_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Classified",
        accessor: "classified",
        Cell: ({ value, row }) => {
          return (
            <p>
              {" "}
              {value == 1
                ? "New"
                : value == 2
                ? "Invalid"
                : value == 3
                ? "Compliant"
                : value == 4
                ? "Non - Compliant"
                : ""}
            </p>
          );
        },
      },
      //   ...(site
      //     ? [
      //         {
      //           Header: "Site Name",
      //           accessor: "siteName",
      //           Cell: ({ value, row }) => {
      //             return <p>{value}</p>;
      //           },
      //         },
      //       ]
      //     : []),
      {
        Header: "Alert Type",
        accessor: "alert_type",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          return <p className="d-flex ac-jc">{value}</p>;
        },
      },
      {
        Header: "Allocated Time",
        accessor: "allocated_at",
        Cell: ({ value, row }) => {
          return <p className="d-flex ac-jc"> {value}</p>;
        },
      },
      {
        Header: "Resource Name",
        accessor: "",
        Cell: ({ value, row }) => {
          let resource_name = "-";
          if (
            row.original.reassigns?.length > 0 &&
            row.original.reassigns?.[row.original.reassigns?.length - 1]
              ?.reassigned_to
          ) {
            resource_name =
              row.original.reassigns?.[row.original.reassigns?.length - 1]
                ?.reassigned_to;
          } else if (row.original.assigned?.assigned_to) {
            resource_name = row.original.assigned?.assigned_to;
          }
          return <p>{resource_name}</p>;
        },
      },
      //   {
      //     Header: "Description",
      //     accessor: "description",
      //     Cell: ({ value, row }) => {
      //       return <p>{value}</p>;
      //     },
      //   },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                <button
                  onClick={() => {
                    navigate("/view-notification-details", {
                      state: {
                        data: row?.original,
                        type: "allocated",
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [site, page]
  );

  return (
    <div className="">
      <h2 className="f3 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-3">
        Total: {pagination?.total ?? 0}
      </h2>

      <div className="d-flex ac-js gap-5 m-2">
        <div className="col-md-2 ">
          <label className="form-label">Select Company</label>
          <SelectBox
            arrayData={comapanyList}
            data={companyData}
            setData={setCompanyData}
            selectedOption={companies}
            setSelectedOption={(val) => {
              setCompanies(val);
              setSites("");
              setSiteList([]);
            }}
            style={true}
          />
        </div>
        <div className="col-md-2 ">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            data={data}
            setData={setData}
            selectedOption={sites}
            setSelectedOption={setSites}
            style={true}
          />
        </div>
      </div>

      <div className="d-flex ac-js gap-5 m-2">
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="search-input" style={{ marginTop: "32px" }}>
          <input
            onChange={(e) => {
              setSearchText(e.target.value);
              // getNotification(
              //   fromDate,
              //   toDate,
              //   e.target.value,
              //   typeDrop,
              //   cam,
              //   sites,
              //   page
              // );
            }}
            value={searchText}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={search_icon} className="search" />
        </div>

        <div className="d-flex flex-row justify-content-end col-md-3 gap-2">
          <button
            className={`submit-btn mt-4 ${
              companies?.value && sites?.value ? "" : "opacity-50"
            }`}
            style={{ width: "100px" }}
            onClick={() =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                sites,
                page,
                sites
              )
            }
            // onClick={() => getNotification("", "", "", "", "", "", 1)}
            disabled={companies?.value && sites?.value ? false : true}
          >
            Filter
          </button>
          <button
            className={`submit-btn mt-4 ${
              companies?.value && sites?.value ? "" : "opacity-50"
            }`}
            style={{ width: "100px" }}
            onClick={() => getNotification("", "", "", "", "", "", 1, sites)}
            disabled={companies?.value && sites?.value ? false : true}
          >
            Refresh
          </button>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={(val) => {
          setPage(val);
          getNotification(
            fromDate,
            toDate,
            searchText,
            typeDrop,
            cam,
            sites,
            val,
            sites
          );
        }}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default Allocated;
